import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpEventType,HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { faKiss } from '@fortawesome/free-solid-svg-icons';

@Injectable({
  providedIn: 'root',
})
export class CampaignService {
  private campaignVoucher: BehaviorSubject<String> = new BehaviorSubject<String>("");
  campaignDetail = this.campaignVoucher.asObservable();
  private campaignStatusChange: BehaviorSubject<String> = new BehaviorSubject<String>("");
  campaignStatusResponse = this.campaignStatusChange.asObservable();
  private deleteCampaignSbj: Subject<String> = new Subject<String>();
  deleteCampaignResponse = this.deleteCampaignSbj.asObservable();

  constructor(private http: HttpClient) { }

  public getCampaignList(page: number, campaignsearch: string,fromDate:any, todate:any, sort?:any) {
    let params = new HttpParams();
    if (fromDate) {
      params = params.set('startDate', fromDate)
    }
    if (todate) {
      params = params.set('endDate', todate)
    }
    if (page) {
      params = params.set('page', page)
    }
      params = params.set('limit', 10)

    if (campaignsearch) {
      params = params.set('search', campaignsearch)
    }

    if (sort) {
      params = params.set('sort', sort)
    }
    return this.http.get<any>(`mhvoucher/campaigns?&${params}`);

  }

  public getActiveCampaignList(count:number){
    let params = new HttpParams();
    params = params.set('active', true)
    params = params.set('limit', count)
    return this.http.get<any>(`mhvoucher/campaigns?&${params}`);
  }

  public getAllCampaignList(count:number){
    let params = new HttpParams();
    params = params.set('limit', count)
    return this.http.get<any>(`mhvoucher/campaigns?&${params}`);
  }

  public getCampaignDetail(id:number){
    return this.http.get<any>('mhvoucher/campaigns/'+id);
  }

  public setCampaignStatusResponse(value:any){
    this.campaignStatusChange.next(value)
  }

  public setCampaignDeletion(value:any){
    this.deleteCampaignSbj.next(value)
  }

  campaignVoucherDetail(value:string) {
    this.campaignVoucher.next(value)
  }

  createCampaignVoucher(campaignId:number,voucherId:number,data:any){
    return this.http.post<any>('mhvoucher/campaigns/'+campaignId+'/vouchers/'+voucherId, data)
  }

  public createCampaign(request: any): Observable<any> {
    return this.http.post('mhvoucher/campaigns', request);
  }
  public getCampaignDetails(idpassed: string) {
    return this.http.get<any>('mhvoucher/campaigns/' + idpassed+'?include=IMAGES')
  }
  public updateCampaign(request: any, idpassed: string) {
    return this.http.patch<any>('mhvoucher/campaigns/' + idpassed, request)
  }

  public deleteCampaign(id: string){
    return this.http.delete<any>('mhvoucher/campaigns/' + id)
  }
  

  public getMerchantList() {
    return this.http.get<any>('mhvoucher/merchants', {
      params: {
        format:'FULL',
      }
    });
  }
  public getPlatformList() {
    return this.http.get<any>('mhvoucher/vouchers/tags');
  }
  public getVoucherList(filter?:string) {
    let headers = new HttpHeaders();
    let params = new HttpParams()
    headers = headers.set('Partner', '1');
    params = params.set('limit', 30)
    if (filter) {
      params = params.set('search', filter)
    }
    return this.http.get<any>(`mhvoucher/vouchers?&${params}`, {
      headers: headers,

    });
  }

  public getVoucherImages() {
    let headers = new HttpHeaders()
    headers = headers.set('partner', '1')
    return this.http.get<any>('mhvoucher/vouchers/images',{headers: headers})
  }

  public getUploadImages(idpassed: string,imageId:string, imageType:string) {
    let headers = new HttpHeaders();
    let formData=new FormData();
    headers = headers.set('partner', '1').set('user-name', 'test-user');
    formData.append('type',imageType);
    formData.append('id',imageId)
    return this.http.patch<any>('mhvoucher/campaigns/' + idpassed+'/images', formData,{headers: headers})
  }

 public  sendImagesFile(id:any, data:any) {
    // let headers = new HttpHeaders()
    // headers = headers.set('user-name', 'SUPER001').set('partner', '1');
    return this.http.patch<any>(`mhvoucher/campaigns/${id}/images`,data)
  }

  public  updateBulkCampaignVoucherStatus(id:any, data:any) {
    return this.http.patch<any>(`mhvoucher/campaigns/${id}/vouchers/status`,data)
  }

}